import { request } from "../../apis";

export const apiGetUserOrderDetail = (params: any): any =>
  request("get", `/api/order/detail`, params, true);
